import { getAuthenticatedFetch } from "../../msal/authenticatedFetchService";

class CustomerService {
    async getAllCustomers() {
        let url = `${process.env.REACT_APP_SELF_SERVICE_CARECOMPLIANCE_API_URL}/Customer`;
        let response = await getAuthenticatedFetch()(url);
        return await response.json();
    }

    async generateDataExport(clientId: number, corporateSiteName: string) {
        let url = `${process.env.REACT_APP_SELF_SERVICE_CARECOMPLIANCE_API_URL}/Customer/${corporateSiteName}/${clientId}/generatedataexport`;
        let response = await getAuthenticatedFetch()(url);

        if (!response.ok) {
            throw new Error();
        }

        return await response.json();
    }

    async getDataExportStatus(taskId: string) {
        let url = `${process.env.REACT_APP_SELF_SERVICE_CARECOMPLIANCE_API_URL}/Customer/getdataexportstatus?` +
            `taskId=${encodeURIComponent(taskId)}`;
        let response = await getAuthenticatedFetch()(url);

        if (!response.ok) {
            throw new Error();
        }

        return await response.json();
    }
}

export default new CustomerService();
